// src/components/StatsBar.jsx
import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { icon: '🧠', value: 500, suffix: '+', label: 'Happy Clients' },
  { icon: '🏆', value: 10,  suffix: '+', label: 'Years Experience' },
  { icon: '💬', value: 20,  suffix: '+', label: 'Specialized Services' },
  { icon: '❤️', value: 100, suffix: '%', label: 'Confidential Care' },
];

const useCountUp = (target, duration = 1800, start = false) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
};

const StatCard = ({ icon, value, suffix, label, delay, triggered }) => {
  const count = useCountUp(value, 1600, triggered);
  return (
    <div
      style={styles.card}
      data-aos="fade-up"
      data-aos-delay={delay}
    >
      <div style={styles.iconWrap}>{icon}</div>
      <div style={styles.number}>
        {triggered ? count : 0}{suffix}
      </div>
      <div style={styles.label}>{label}</div>
    </div>
  );
};

const StatsBar = () => {
  const ref = useRef(null);
  const [triggered, setTriggered] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setTriggered(true); },
      { threshold: 0.4 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section style={styles.section} ref={ref}>
      <div style={styles.container}>
        {stats.map((stat, i) => (
          <StatCard
            key={stat.label}
            {...stat}
            delay={i * 100}
            triggered={triggered}
          />
        ))}
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#1B3F6E',
    padding: '56px 24px',
    position: 'relative',
    overflow: 'hidden',
  },
  container: {
    maxWidth: 1100,
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: 24,
    textAlign: 'center',
  },
  card: {
    padding: '32px 20px',
    borderRadius: 16,
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.12)',
    transition: 'all 0.3s ease',
    cursor: 'default',
  },
  iconWrap: {
    fontSize: 40,
    marginBottom: 12,
    filter: 'drop-shadow(0 2px 8px rgba(90,158,75,0.4))',
  },
  number: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 48,
    fontWeight: 700,
    color: '#ffffff',
    lineHeight: 1,
    marginBottom: 8,
  },
  label: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 14,
    fontWeight: 600,
    color: '#5A9E4B',
    textTransform: 'uppercase',
    letterSpacing: 1.5,
  },
};

export default StatsBar;
